import React, {useEffect, useState} from "react";
import Parser from 'html-react-parser';
import MetaTags from "react-meta-tags";
import {useHistory} from "react-router"

import BreadCrumb from '../../Layout/Funlove/BreadCrumb';
import MovieListComponent from "../Components/MovieListComponent";

import {fetchPornStarDetail} from "./Components/requesApi"
import PornStarList from "./Components/PornStarList";
import {activeMenu} from "../Components";
import BoxAds from "../Components/BoxAds";
import {NavLink} from "react-router-dom";
import AppConstants from "../../Config/AppConstants";


function PornStarDetail(props) {

    const [dataPage, setDataPage] = useState(null);
    let history = useHistory();

    useEffect(() => {
        getData(props.match.params.alias);
        activeMenu('#pornstars');
    }, [props.match.params.alias]);

    const getData = async (alias) => {

        let result = await fetchPornStarDetail(alias);

        if (!result || result.status != 200 || !result.data.data) {
            history.push('/404');
            return false
        }
        window.scrollTo(0, 0);
        setDataPage(result.data.data);
    }

    if (!dataPage) {

        return <></>
    }
    let detail = dataPage.detail;

    return (
        <>
            <MetaTags>
                <title>{`${detail.name}`}</title>
                <meta name="description"
                      content={`${detail.name} Is A Porn Actor`}/>
              <meta name="keywords"
                      content={`${detail.name}, ${detail.name} porn, ${detail.name} hd, ${detail.name} models, ${detail.name} pornstar, ${detail.name} ido`}/>

                <link rel="canonical" href={`${AppConstants.domainPage}pornstar/${detail.alias}`}/>
                <meta property="og:locale" content="en_us"/>
                <meta property="og:type" content="website"/>
               <meta property="og:site_name" content={AppConstants.pageName}/>
                <meta property="url" content={`${AppConstants.domainPage}`}/>
                <meta property="image" content={detail.image}/>
            </MetaTags>
            <BreadCrumb/>
            <section className="breadcrumb-wrapper visible-md-block visible-lg-block">
                <div className="container">
                    <ol className="breadcrumb">
                        <li>
                            <NavLink to='/' title='Home'>
                                <i className="glyphicon glyphicon-home"></i> Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to='/pornstars' title='Pornstars'>
                                Pornstars
                            </NavLink>
                        </li>
                        <li className="active">{detail.name}</li>
                    </ol>
                </div>
            </section>
            <p style={{height: 1}}></p>
            <BoxAds></BoxAds>
            <div className="container">

                <div className="box">
                    <h1 className="title" style={{border: 0}}>{detail.name}</h1>
                    <div className="col-md-2 col-sm-4">
                        <div className="pornstar-detail-image" style={{padding: 10}}>
                            <img
                                src={detail.image}
                                alt={detail.name}
                                title={detail.name}
                                className="img-responsive"
                                style={{width: "100%"}}
                            />
                        </div>
                    </div>
                    <div className="col-md-10 col-sm-8">
                        <div className="pornstar-detail-info">

                            {detail.descriptions ?
                                (Parser(detail.descriptions)) :
                                ('')
                            }
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <BoxAds></BoxAds>

                <div className="box">
                    <h3 className="title" style={{float: 'left'}}>Porn Movies with {detail.name} </h3>
                    <span className="movie-number">({detail.videos_count})  </span>
                    <MovieListComponent movieList={detail.videos}/>

                    <div className="clearfix"></div>
                </div>
                <BoxAds></BoxAds>
                <div className="box">
                    <h3 className="title">Related Pornstars</h3>
                    <PornStarList pornStarList={dataPage.pornStarSuggested}/>
                    <div className="clearfix"></div>
                </div>
                <BoxAds></BoxAds>
                <div className="box">
                    <div className="clearfix"></div>
                    <h3 className="title">Suggested videos</h3>

                    <MovieListComponent movieList={dataPage.movieSuggested}/>

                    <div className="clearfix"></div>
                </div>
            </div>

            <BoxAds/>
        </>
    )
}

export default PornStarDetail;
